export default __webpack_public_path__ + "static/media/work_ec-notifications.e252b65f.jpg";